import { defineSlotRecipe } from '@chakra-ui/react';

export const sectionHeadingRecipe = defineSlotRecipe({
    slots: ['root', 'title', 'subtitle', 'separator'],
    base: {
        root: {
            // Default gap below the heading block; callers override with a
            // plain `mb` (unlayered element css beats @layer recipes) or the
            // legacy `spacing` prop.
            mb: 2,
        },
        title: {
            textStyle: 'heading-4',
        },
        subtitle: {
            textStyle: 'body-5',
            color: 'fg.muted',
        },
        // Margins only — the border itself comes from Chakra's stock
        // separator recipe on the wrapped <Separator>, so the two recipes
        // never style the same property.
        separator: {
            mt: 2,
            mb: 4,
        },
    },
});
